<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav3_blue.svg" alt="">小テストマスタ</h1>
      <div class="l-btn-createnew_pos">
        <div class="btn-create-new_wh" @click="goInput()" :disabled="isProcessing"><a>新規作成</a></div>
      </div>
      <div class="l-contentsBox">
        <table class="table-base audit-table table-select mt-30">
          <colgroup>
            <col style="width: 120px;">
            <col style="width: 100px;">
            <col style="width: 100px;">
            <col>
          </colgroup>
          <thead>
            <th>小診断名</th>
            <th>開始日</th>
            <th>終了日</th>
          </thead>
          <tbody>
            <tr v-for="roughDiag in roughDiagList" :key="roughDiag.roughDiagId" @click="goEdit(roughDiag.roughDiagId)">
              <td>{{ roughDiag.title }}</td>
              <td>{{ roughDiag.fromDt }}</td>
              <td>{{ roughDiag.toDt }}</td>
            </tr>
          </tbody>
        </table>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';

export default {
  components: {
    Loading,
    Pagination,
  },
  data() {
    return {
      isProcessing: false,
      pageInfo: {},
      roughDiagList: []
    }
  },
  created: function () {
    this.getRoughDiagList(1);
  },
  methods: {
    emitChangePage(page) {
      this.getRoughDiagList(page)
    },
    async getRoughDiagList(page) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/roughDiag/getRoughDiagList', {
        page: page,
      });
      if (res) {
        this.roughDiagList = res.data.roughDiagList.data;
        this.pageInfo = {
          currentPage: res.data.roughDiagList.currentPage,
          lastPage: res.data.roughDiagList.last_page,
          total: res.data.roughDiagList.total,
          from: res.data.roughDiagList.from,
          to: res.data.roughDiagList.to,
        };
      }
      this.isProcessing = false;
    },
    goInput() {
      this.$store.dispatch('master/setRoughDiagId', null);
      this.$router.push({ name: 'rough-diag-master-new' });
    },
    goEdit(roughDiagId) {
      this.$store.dispatch('master/setRoughDiagId', roughDiagId);
      this.$router.push({ name: 'rough-diag-master-edit' } );
    }
  },
}
</script>